import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faCoffee,
  faUser,
  faCheck,
  faXmark,
  faBars,
  faLessThan,
  faGreaterThan,
  faChevronLeft,
  faChevronRight,
  faPencil,
  faPen
} from "@fortawesome/free-solid-svg-icons";

import { faTwitter, faGithub } from "@fortawesome/free-brands-svg-icons";

library.add(
  faCoffee,
  faUser,
  faCheck,
  faTwitter,
  faGithub,
  faXmark,
  faBars,
  faLessThan,
  faGreaterThan,
  faChevronLeft,
  faChevronRight,
  faPencil,
  faPen
);
